import { useContext } from 'react';
import { MenuContext, MenuContextType } from '#baseMenu/contexts';

const useMenuContext = () => useContext<MenuContextType>(MenuContext);

export { useMenuContext };
